import { useEffect } from "react";
import React from "react";
import { useAnalytics } from "../hooks/useAnalytics";

const MobileRedirect = () => {
  useAnalytics();

  useEffect(() => {
    window.location.href = `${process.env.REACT_APP_API}/mobile`;
  }, []);

  return <p>Redirecting to NimbleCasa app...</p>;
};

export default MobileRedirect;
